interface Ilocation {
  state: {
    addressType: string;
    locationSelector: string;
    dataSource: string;
    address: null;
    company: string;
  };
}

const initialFilters = (location: Ilocation) => {
  if (!location.state) return {};

  const filters: any = location.state;
  const filterObj: any = {};

  if (filters.payment_location && filters.payment_location !== "all") {
    filterObj.payment_location = [filters.payment_location_label];
  }

  if (filters.addressType === "address") {
    const cityKey = filters.locationSelector === "origin" ? "pickup_city" : "delivery_city";
    const cityValue = filters.address.city;
    filterObj[cityKey] = cityValue;
  }

  if (filters.addressType === "seaport" || filters.addressType === "airport") {
    const locodeKey = filters.locationSelector === "origin" ? "pol_locode" : "pod_locode";
    const locodeValue = filters.address.value;
    filterObj[locodeKey] = locodeValue;
  }

  if (filters.addressType === "company") {
    const companyKey = filters.locationSelector === "origin" ? "origin_name" : "destination_name";
    const companyValue = filters.company;
    filterObj[companyKey] = companyValue;
  }

  return filterObj;
};

export default initialFilters;
